import { Option } from 'common/components/Inputs/Autocomplete/utils/models';
import { uniqBy } from 'lodash';

export const filterOptionsArray = <T extends { id: string | null }>(options: T[]) => {
  return uniqBy(options, 'id');
};

const filterOptionByName = (options: Option[], inputValue: string) => {
  const searchText = inputValue.toLowerCase();
  return options.filter((option: Option) => {
    const optionName = option.name.toLowerCase();
    return optionName.includes(searchText);
  });
};

const filterOptionById = (options: Option[], inputValue: string) => {
  const searchId = inputValue.toLowerCase();

  return options.filter((option: Option) => {
    const idText = String(option.id).toLowerCase();
    return idText.includes(searchId);
  });
};

export const filterOptions = (
  options: Option[],
  inputValue: string,
  allowFilteringById: boolean,
) => {
  const itemsFilteredByName = filterOptionByName(options, inputValue);
  const itemsFilteredById: Option[] = allowFilteringById
    ? filterOptionById(options, inputValue)
    : [];

  return filterOptionsArray([...itemsFilteredByName, ...itemsFilteredById]);
};
